import { KeyRound } from "lucide-react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Section, Loadable, Status, useLoad, fmt } from "@/components/control/kit";

const yesNo = (v) => (v === null || v === undefined ? "–" : v ? "ja" : "nein");

function KeyTable({ keys }) {
  return (
    <Table data-testid="admin-config-keys">
      <TableHeader><TableRow><TableHead>Schlüssel</TableHead><TableHead>Status</TableHead><TableHead>Quelle</TableHead><TableHead>Hinweis</TableHead></TableRow></TableHeader>
      <TableBody>
        {keys.map((k) => (
          <TableRow key={k.key} data-testid={`admin-config-key-${k.key}`}>
            <TableCell className="font-mono text-xs">{k.key}</TableCell>
            <TableCell><Status value={k.state} testId={`admin-config-key-state-${k.key}`} /></TableCell>
            <TableCell className="font-mono text-xs">{k.source || "–"}</TableCell>
            <TableCell className="text-xs text-muted-foreground">{k.note || "–"}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}

function AccountRow({ a }) {
  return (
    <li className="py-3" data-testid={`admin-config-account-${a.slot}`}>
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div>
          <p className="font-medium text-brand-purple">{a.person} · erwartet: {a.expected_role_label}</p>
          <p className="text-xs text-muted-foreground">
            Identität {a.identity || "nicht hinterlegt"} · Rolle laut Server {a.role_label || "–"} · Zweiter Faktor eingerichtet {yesNo(a.twofa_confirmed)} · Passwort entspricht Geheimnis {yesNo(a.password_matches_hash)}
          </p>
        </div>
        <Status value={a.state} testId={`admin-config-account-state-${a.slot}`} />
      </div>
      {[...a.problems, ...a.notes].map((t) => <p key={t} className="mt-1 text-xs text-orange-800">{t}</p>)}
    </li>
  );
}

export function AdminConfigStatus() {
  const st = useLoad("/system/admin-config");
  return (
    <Section title={<span className="flex items-center gap-2"><KeyRound className="h-5 w-5 text-brand-magenta" /> Konfigurationsschlüssel (maskiert)</span>} testId="admin-config-status">
      <Loadable state={st}>
        {(d) => (
          <div className="space-y-5">
            <p className="text-sm">Umgebung <strong data-testid="admin-config-env">{d.environment}</strong> · geprüft {fmt(d.checked_at)} · Konflikte <strong data-testid="admin-config-conflicts">{d.conflict_count}</strong></p>
            <div className="overflow-x-auto"><KeyTable keys={d.keys} /></div>
            <ul className="divide-y divide-border" data-testid="admin-config-accounts">{d.accounts.map((a) => <AccountRow key={a.slot} a={a} />)}</ul>
            {d.problems.map((t) => <p key={t} className="text-sm text-red-700">{t}</p>)}
            <ul className="space-y-1 rounded-lg bg-secondary/70 p-3 text-xs">{d.notes.map((t) => <li key={t}>{t}</li>)}</ul>
          </div>
        )}
      </Loadable>
    </Section>
  );
}
